import React, { useEffect, useState } from "react";
import { Imagesdata } from "../../assets/images/imageData";
import Layout from "../../layout";
import { useForm } from "react-hook-form";
import { ErrorMessage } from "@hookform/error-message";
import validation from "./validation";
import { Button, Modal, Form, Container, Row, Col } from "react-bootstrap";
import { InputField } from "../../components/InputField/InputField";
import services from "../../API/services";
import { getPropertyUsersAction, usersSeletor } from "../../store/slices/userSlice";
import { useDispatch, useSelector } from "react-redux";
import { authenticationSeletor } from "../../store/slices/authenticationSlice";
import { toast } from "react-toastify";
import decodeEntities from "../../Common/DecodeHtml";
import { useDownloadExcel } from "react-export-table-to-excel";
import { useRef } from "react";
import { USER_DEG_TEXT, USER_DEG_TEXT_WITH_ANUM } from "../../constant/constants";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import MultiSelectInput from "../../components/multiSelect";
import { assignUnassignPropertyUser } from "../../API/services/newServices";
import { useNavigate } from "react-router-dom";
import ReactGA from "react-ga4";
import { createPropertyLogs } from "store/slices/PropertyData";

const propertyUserRoles = {
  3: [4, 5, 6, 15, 16, 17, 18, 19, 20, 21, 24, 22, 27, 23, 25, 26, 28],
  4: [5, 6, 15, 16, 17, 18, 19, 20, 21, 24, 22, 27, 23, 25, 26, 28],
  5: [6, 15, 16, 17, 18, 19, 20, 21, 24, 22, 27, 23, 25, 26, 28],
  6: [15, 16, 17, 18, 19, 20, 21, 24, 22, 27, 23, 25, 26],
  15: [16, 17, 18, 19, 20, 21, 24],
  19: [20],
  22: [27, 23],
}

const PropertyUsers = () => {
  const dispatch = useDispatch();
  const { propertyUsers } = useSelector(usersSeletor);
  const { showProperties } = useSelector((s) => s.AllData);
  const { userDetail } = useSelector(authenticationSeletor);
  const [propertyList, setPropertyList] = useState([]);
  const [show, setShow] = useState(false);
  const [userList, setUserList] = useState([]);
  const [showUserList, setShowUserList] = useState([]);
  const [selectData, setSelectData] = useState({});
  const [showAllRoles, setShowAllRoles] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [removeSelectedItems, setRemoveSelectedItems] = useState([]);
  const [newSelectedItem, setNewSelectedItem] = useState([]);
  const [onlyPropertyAssign, setOnlyPropertyAssign] = useState(false);
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [otherErrors, setOtherErrors] = useState({});

  const { register, handleSubmit, reset, setValue, formState: { errors } } = useForm({ ...validation, mode: "onSubmit" });

  useEffect(() => {
    ReactGA.send({ hitType: "pageview", page: "property_users" });
    setPropertyList(showProperties);
  }, [showProperties]);

  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
    dispatch(getPropertyUsersAction(userDetail.propertyId));
  }, [selectedItems]);

  useEffect(() => {
    let getUsers = [];
    propertyUsers.map((data) => {
      if (userDetail?.propertyId == data.propertyId || data.UserProperties?.some((item) => item.propertyId == userDetail?.propertyId)) { getUsers.push(data); }
    });
    setUserList(userDetail?.logintype == "rroomUser" ? propertyUsers : getUsers);
  }, [propertyUsers, userDetail]);

  const { AlertIcon } = Imagesdata || {};

  const assignUnassign = async (e) => {
    e.preventDefault();
    const res = await assignUnassignPropertyUser({
      assigneProperty: newSelectedItem,
      status: true,
      createdBy: userDetail?.id,
      propertyUserId: selectData.id,
    });
    if (onlyPropertyAssign && res.status === 200) {
      dispatch(getPropertyUsersAction(userDetail.propertyId));
      toast.success(`Property assigned to user successfull!`, { autoClose: 1000, pauseOnHover: true, position: "top-right" });
      const params = {
        action: `Property Assigned`,
        actionBy: userDetail?.firstName + ' ' + userDetail?.lastName,
        operation: JSON.stringify({ 'Username': selectData?.firstName, 'Assigned Properties': newSelectedItem }),
        propertyId: userDetail?.propertyId
      }
      dispatch(createPropertyLogs(params))
    }
    setOnlyPropertyAssign(false);
    setSelectedItems([]);
    setNewSelectedItem([])
    setShow(false);
  };

  const onSubmit = async (payload) => {
    const realPayload = {
      firstName: payload.firstName,
      lastName: payload.lastName,
      name: payload.firstName + " " + payload.lastName,
      email: payload.email,
      mobile: payload.phoneNumber,
      role: Number(payload.role),
      password: payload.password,
      propertyId:
        userDetail?.logintype == "rroomUser"
          ? payload.property
          : userDetail?.propertyId,
      assignedProperty: payload.assignedProperty,
      designation: payload.designation,
      // agreement: 0,
    };
    let params = {
      action: `Property User ${editMode ? 'Modified' : 'Created'}`,
      actionBy: userDetail?.firstName + ' ' + userDetail?.lastName,
      propertyId: userDetail?.propertyId,
      operation: {}
    };
    if (editMode) {
      if (selectData.firstName !== payload.firstName || selectData.lastName !== payload.lastName) {
        params.operation.Name = `${selectData.firstName} ${selectData.lastName} → ${payload.firstName} ${payload.lastName}`;
      }
      if (selectData.email !== payload.email) {
        params.operation.Email = `${selectData.email} → ${payload.email}`;
      }
      if (selectData.mobile !== payload.phoneNumber) {
        params.operation.Mobile = `${selectData.mobile} → ${payload.phoneNumber}`;
      }
      if (selectData.Role?.id != payload.role) {
        params.operation.Role = `${selectData.Role?.id} → ${payload.role}`;
      }
      if (selectData.designation !== payload.designation) {
        params.operation.Designation = `${selectData.designation} → ${payload.designation}`;
      }
      params.operation = Object.keys(params.operation).length
        ? JSON.stringify(params.operation)
        : "";
    } else {
      params.operation = JSON.stringify({
        Name: `${payload.firstName} ${payload.lastName}`,
        Email: payload.email,
        Mobile: payload.phoneNumber,
        Role: payload.role,
        Designation: payload.designation,
        "Assigned Properties": payload.assignedProperty
      });
    }
    try {
      let msg = "";
      let res = {};
      if (editMode) {
        realPayload.updatedBy = userDetail?.logintype != "rroomUser" ? userDetail?.id : 0;
        res = await services.user.editPrtUserService(selectData.id, realPayload);
        msg = "Updated";
      } else {
        realPayload.createdBy = userDetail?.logintype != "rroomUser" ? userDetail?.id : 0;
        res = await services.user.addPropertyUserService(realPayload);
        msg = "Created";
      }
      setEditMode(false);
      if (res.status == 200) {
        if (!res.data.status) {
          toast.error(`user with email and phone already exist*`);
          return;
        }
        dispatch(createPropertyLogs(params))
        reset();
        dispatch(getPropertyUsersAction(userDetail.propertyId));
        setShow(false);
        setValue("designation", "");
        setValue("role", "");
        toast.success(`Property User ${msg} SuccessFull !`);
      }
    } catch (error) { console.log("error in onSubmit") }
  };

  const getRoles = async () => {
    if (showAllRoles.length > 4) { return; }
    const res = await services.auth.getAllRoles();
    if (res.status == 200) { setShowAllRoles(res.data.data); }
  };

  const tableRef = useRef(null);
  const { onDownload } = useDownloadExcel({ currentTableRef: tableRef.current, filename: "Users table", sheet: "Users" });

  const deleteHandler = async (id) => {
    if (window.confirm("Are you sure want to delete User")) {
      try {
        const res = await services.auth.deletePrtUser(id);
        if (res.status == 200) {
          dispatch(getPropertyUsersAction(userDetail.propertyId));
          toast.success("User Deleted Successfull !", { autoClose: 1000, pauseOnHover: true, position: "top-right" });
        }
      } catch (error) { console.log("error in deleteHandler") }
    }
  };

  const editHandler = async (data, forAssign = false) => {
    setShow(true);
    setSelectData(data);
    if (forAssign) {
      setOnlyPropertyAssign(true);
      setRemoveSelectedItems(data.UserProperties);
      setSelectedItems(data.UserProperties ? data.UserProperties?.map((i) => i.propertyId) : []);
      return;
    }
    getRoles();
    setOnlyPropertyAssign(false);
    setEditMode(true);
    setValue("firstName", data.firstName);
    setValue("lastName", data.lastName);
    setValue("email", data.email);
    setValue("phoneNumber", data.mobile);
    setValue("designation", data.designation);
    setValue("password", data.password);
    setValue("confirmPassword", data.password);
    setValue("role", data.Role.id);
    setValue("property", data.propertyId);
  };

  const searchfilter = (text) => {
    const results = userList.filter((item) => {
      if (text == "") return userList;
      return (
        USER_DEG_TEXT[item?.designation] +
        item?.firstName +
        item?.lastName +
        item?.email +
        item?.mobile +
        item?.userCode +
        item?.Role?.roleName
      )?.toString().toLowerCase()?.includes(text?.toLowerCase());
    });
    setShowUserList(results);
  };

  useEffect(() => { setShowUserList(userList) }, [userList]);

  const updateSelectedProperty = (properties) => {
    setNewSelectedItem(properties.filter(value => !selectedItems.includes(value)));
    setValue("assignedProperty", properties);
  };

  const openAddHandler = () => { getRoles(); setShow(true) };

  const changeHandler = ({ value }) => {
    const results = userList.filter((item) => {
      if (!value) return userList;
      return item.propertyId == value;
    });
    setShowUserList(results);
  };

  const validate = () => {
    const newErrors = {};
    if (!password) {
      newErrors.password = 'Password is required';
    } else if (password.length < 4) {
      newErrors.password = 'Password must be at least 6 characters';
    }
    if (!confirmPassword) {
      newErrors.confirmPassword = 'Confirm Password is required';
    } else if (password !== confirmPassword) {
      newErrors.confirmPassword = 'Passwords do not match';
    }
    setOtherErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const [selectedPropertyUser, setSelectedPropertyUser] = useState(null)
  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    if (validate()) {
      const payload = { password: password, role: userDetail?.role }
      const res = await services.auth.propertyUserChangePasswordService(selectedPropertyUser?.id, payload)
      if (res.status == 200 && res.data.status == true) {
        toast.success(res.data.message, { autoClose: 1000, pauseOnHover: true, position: "top-right" });
        setSelectedPropertyUser(null)
      }
    }
  };

  const allowedRoles = propertyUserRoles[userDetail?.role]

  return (
    <Layout
      // wantSearchableListFor="property"
      title="Property Users"
      buttonTitle={userDetail?.logintype === "propertyUser" ? "Create New User" : undefined}
      openHandler={userDetail?.logintype === "propertyUser" ? openAddHandler : undefined}
      extraButton="Export Table"
      extraBtnHandler={onDownload}
      searchfilter={searchfilter}
      changeHandler={changeHandler}
    >
      <table className="dashboard-table" ref={tableRef}>
        <thead>
          <tr>
            {userDetail?.logintype == "rroomUser" && <th>Property Name</th>}
            <th>User Code</th>
            <th>Name</th>
            <th>Designation</th>
            <th style={{ minWidth: 150 }}>Role</th>
            <th>Created</th>
            <th>Edited</th>
            <th>Email</th>
            <th>mobile</th>
            {userDetail.Role?.canEdit == 1 && userDetail.Role?.canDelete == 1 && (<th>Action</th>)}
          </tr>
        </thead>
        <tbody>
          {[...showUserList].reverse().map((data, key) => (
            <tr key={key}>
              {userDetail?.logintype == "rroomUser" && (
                <td data-label="Property Name">{propertyList.map((dataInner) => { if (dataInner.id == data.propertyId) { return dataInner.name; } })}</td>
              )}
              <td data-label="User Code">{data.userCode}</td>
              <td data-label="Name">{data.firstName + " " + data.lastName}</td>
              <td data-label="Designation">{USER_DEG_TEXT[data.designation]}</td>
              <td data-label="Role">{data.Role?.roleName}</td>
              <td data-label="Created By">{data.CreatedByUser ? data?.CreatedByUser?.firstName : "RROOMS"}</td>
              <td data-label="Edited By">{data.UpdatedByUser ? data?.UpdatedByUser?.firstName : "-"}</td>
              <td data-label="Email">{"123".includes(userDetail.role) ? data.email ? decodeEntities(data.email) : "N/A" : "******@gmail.com"}</td>
              <td data-label="mobile">{"123".includes(userDetail.role) ? data.mobile : "**********"}</td>
              {userDetail.Role?.canEdit == 1 &&
                userDetail.Role?.canDelete == 1 && (
                  <td data-label="Action" className="action">
                    <div className="right-sm">
                      {
                        (userDetail?.logintype == "propertyUser") ||
                          (userDetail?.role == 3 && userDetail?.role == 4) ?
                          <button
                            type="button"
                            className="btn btn-primary btn-sm mr-1"
                            onClick={() => setSelectedPropertyUser(data)}>
                            Change
                          </button> : ''
                      }
                      {userDetail.Role?.canEdit == 1 && (
                        <>
                          {userDetail?.logintype == "rroomUser" ? null : (
                            <>
                              {userDetail?.Role?.id == 3 ?
                                <Button variant="success" className="mr-1 btn-sm" onClick={() => navigate(`/property-users/module-configuration/${data.id}`)}>
                                  Config Menu{" "}
                                  <FontAwesomeIcon icon="fa-solid fa-bars" />
                                </Button>
                                : null}
                              <Button variant="primary" className="mr-1 btn-sm" onClick={() => editHandler(data, true)}>
                                Assign{" "}
                                <FontAwesomeIcon icon="fa-solid fa-building" />
                              </Button>
                            </>
                          )}
                          <Button variant="primary" className="mr-1 btn-sm" onClick={() => editHandler(data)}>
                            <FontAwesomeIcon icon="fa-solid fa-pen-to-square" />
                          </Button>
                        </>
                      )}

                      {
                        (userDetail?.logintype == "propertyUser" && userDetail?.role == 3) && (
                          <Button variant="danger" className="btn-sm" onClick={() => deleteHandler(data.id)}>
                            <FontAwesomeIcon icon="fa-solid fa-trash" />
                          </Button>
                        )
                      }
                    </div>
                  </td>
                )}
            </tr>
          ))}
        </tbody>
      </table>
      <div className={`otpModal  ${selectedPropertyUser ? 'active' : ''}`}>
        <div className="innerOtpModal" style={{ minWidth: '400px' }}>
          <section className=" verify-otp-booking position-relative">
            <button className="btn closeBtn text-black position-absolute top-0 end-0 m-0" onClick={() => setSelectedPropertyUser(null)}>
              <FontAwesomeIcon icon="fa-solid fa-x" />
            </button>
            <div className="title text-black fs-4 text-left pb-4">Change Password</div>
            <form onSubmit={handlePasswordSubmit}>
              <div className="form-group">
                <label className="field-label text-left">New Password</label>
                <input type="text" value={password} onChange={(e) => setPassword(e.target.value)} className="field-control" placeholder="New Password" />
                {otherErrors.password && <span className="d-block text-left" style={{ color: 'red' }}>{otherErrors.password}</span>}
              </div>
              <div className="form-group">
                <label className="field-label text-left">Confirm New Password</label>
                <input type="text" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} className="field-control" placeholder="Confirm New Password" />
                {otherErrors.confirmPassword && <span className="d-block text-left" style={{ color: 'red' }}>{otherErrors.confirmPassword}</span>}
              </div>
              <div className="form-group">
                <button type="submit" className="btn btn-primary" disabled={!password || !confirmPassword || Object.keys(errors).length > 0}>
                  Submit
                </button>
              </div>
            </form>
          </section>
        </div>
      </div>
      <Modal
        show={show}
        onHide={() => {
          setShow(false);
          reset();
          setValue("designation", "");
          setValue("role", "");
          setOnlyPropertyAssign(false);
          setEditMode(false);
          setNewSelectedItem([])
        }}
        size="lg"
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title>{onlyPropertyAssign ? "Assign Property" : "User details"}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form className="popup-form onboardForm" onSubmit={onlyPropertyAssign ? assignUnassign : handleSubmit(onSubmit)}>
            <Container>
              <Row>
                <Col xs={12} className="form-group"></Col>
                {!onlyPropertyAssign && (
                  <>
                    <Col xs={6} className="form-group">
                      <InputField
                        htmlFor="firstName"
                        text="First Name"
                        type="text"
                        autoFocus={true}
                        placeholder="Enter first name"
                        field={"firstName"}
                        register={register}
                        errors={errors}
                      />
                      {errors?.firstName?.message && (
                        <div className="error-text">
                          <img alt="" src={AlertIcon} />
                          <span>
                            <ErrorMessage errors={errors} name={"firstName"} />
                          </span>
                        </div>
                      )}
                    </Col>
                    <Col xs={6} className="form-group">
                      <InputField
                        htmlFor="lastName"
                        text="Last Name"
                        type="text"
                        placeholder="Enter Last name"
                        field={"lastName"}
                        register={register}
                        errors={errors}
                      />
                      {errors?.lastName?.message && (
                        <div className="error-text">
                          <img alt="" src={AlertIcon} />
                          <span>
                            <ErrorMessage errors={errors} name={"lastName"} />
                          </span>
                        </div>
                      )}
                    </Col>
                    <Col xs={6} className="form-group">
                      {/* <InputField
                        htmlFor="phoneNumber"
                        text="Phone No."
                        type="text"
                        placeholder="Enter phone number"
                        field={"phoneNumber"}
                        register={register}
                        errors={errors}
                      /> */}
                      <label>Phone No.</label>
                      <input
                        id="phoneNumber"
                        type="text"
                        placeholder="Enter Phone Number"
                        className={`form-control border ${errors.phoneNumber ? "border-danger" : ""}`}
                        maxLength={10}
                        {...register("phoneNumber", {
                          required: "Phone Number number is required",
                          pattern: {
                            value: /^[0-9]{10}$/,
                            message: "Enter a valid 10-digit number",
                          },
                        })}
                        onInput={(e) => (e.target.value = e.target.value.replace(/\D/g, ""))}
                      />
                      {errors?.phoneNumber?.message && (
                        <div className="error-text">
                          <img alt="" src={AlertIcon} />
                          <span>
                            <ErrorMessage
                              errors={errors}
                              name={"phoneNumber"}
                            />
                          </span>
                        </div>
                      )}
                    </Col>
                    <Col xs={6} className="form-group">
                      <InputField
                        htmlFor="email"
                        text="Email address "
                        type="email"
                        placeholder="Enter email address"
                        field={"email"}
                        register={register}
                        errors={errors}
                      />
                      {errors?.email?.message && (
                        <div className="error-text">
                          <img alt="" src={AlertIcon} />
                          <span>
                            <ErrorMessage errors={errors} name={"email"} />
                          </span>
                        </div>
                      )}
                    </Col>
                    {userDetail?.logintype == "rroomUser" ? (
                      <Col xs={12} className="form-group">
                        <label>Property</label>
                        <select register={register} {...register("property")}>
                          <option disabled selected value="">
                            Select property
                          </option>
                          {propertyList.map((innerData, key) => (
                            <option key={key} value={innerData.id}>
                              {innerData.name}
                            </option>
                          ))}
                        </select>
                      </Col>
                    ) : null}
                    <Col xs={6} className="form-group flex flex-column">
                      <label>Role</label>
                      <select
                        style={{ height: 45, outline: 0 }}
                        register={register}
                        {...register("role")}
                        className={`formControl border`}
                      >
                        <option disabled selected value="">
                          Select User Role
                        </option>

                        {
                          showAllRoles?.filter((data) => data.roleName.startsWith('PROPERTY') && allowedRoles.includes(data?.id)).map((item) => {
                            return (
                              <option value={item.id} key={item.id}>
                                {item.roleName}
                              </option>
                            );
                          })
                        }
                      </select>
                      {errors?.role?.message && (
                        <div className="error-text">
                          <img alt="" src={AlertIcon} />
                          <span>
                            <ErrorMessage errors={errors} name={"role"} />
                          </span>
                        </div>
                      )}
                    </Col>
                    <Col xs={6} className="form-group flex flex-column">
                      <label>Designation</label>
                      <select
                        style={{ height: 45, outline: 0 }}
                        register={register}
                        {...register("designation")}
                        className={`formControl border`}
                      >
                        <option disabled selected value="">
                          Select User Designation
                        </option>
                        {userDetail.designation == "1"
                          ? USER_DEG_TEXT_WITH_ANUM.map((item, ind) => {
                            return (
                              <option value={item.value} key={ind}>
                                {item.name}
                              </option>
                            );
                          })
                          : USER_DEG_TEXT_WITH_ANUM.map((item, ind) => {
                            if (userDetail.designation < item.value) {
                              return (
                                <option value={item.value} key={ind}>
                                  {item.name}
                                </option>
                              );
                            }
                          })}
                      </select>
                      {errors?.designation?.message && (
                        <div className="error-text">
                          <img alt="" src={AlertIcon} />
                          <span>
                            <ErrorMessage
                              errors={errors}
                              name={"designation"}
                            />
                          </span>
                        </div>
                      )}
                    </Col>
                    {!editMode && (
                      <>
                        <Col xs={6} className="form-group">
                          <InputField
                            htmlFor="password"
                            text="Create Password"
                            type="password"
                            placeholder="Enter new password"
                            field={"password"}
                            register={register}
                            errors={errors}
                          />
                          {errors?.password?.message && (
                            <div className="error-text">
                              <img alt="" src={AlertIcon} />
                              <span>
                                <ErrorMessage
                                  errors={errors}
                                  name={"password"}
                                />
                              </span>
                            </div>
                          )}
                        </Col>
                        <Col xs={6} className="form-group">
                          <InputField
                            htmlFor="confirmPassword"
                            text="Confirm Password"
                            type="password"
                            placeholder="Enter confirm password"
                            field={"confirmPassword"}
                            register={register}
                            errors={errors}
                          />
                          {errors?.confirmPassword?.message && (
                            <div className="error-text">
                              <img alt="" src={AlertIcon} />
                              <span>
                                <ErrorMessage
                                  errors={errors}
                                  name={"confirmPassword"}
                                />
                              </span>
                            </div>
                          )}
                        </Col>
                      </>
                    )}
                  </>
                )}

                {!editMode && (
                  <MultiSelectInput
                    onChange={updateSelectedProperty}
                    selectedItems={selectedItems}
                    removeSelectedItems={removeSelectedItems}
                    setRemoveSelectedItems={setRemoveSelectedItems}
                    setSelectedItems={setSelectedItems}
                    setNewSelectedItem={setNewSelectedItem}
                    newSelectedItem={newSelectedItem}
                  />
                )}
                <Col xs={12} className="form-group">
                  <Button variant="primary" type="submit"
                    disabled={!editMode && !newSelectedItem.length}
                  >
                    Submit
                  </Button>
                </Col>
              </Row>
            </Container>
          </Form>
        </Modal.Body>
      </Modal>
    </Layout>
  );
};

export default PropertyUsers;
